
import { combineReducers } from "redux";
import AdminReducer from './admin'

export default combineReducers({AdminReducer });
